
export default {
  props:{
    height:{},
    cart:{}
  },
  data() {
    return {
      tab: false,
    };
  },
};
